<template>
	<div>
		<template v-for="(content, i) in componentItem.content">									
			<div :key="`${i}animated-image${index}`">
				<div v-if="typeof content !== 'object' && (i == 'title' || i == 'text-color')" >
					<div class="form-group">
						<label>{{ i }}</label>	
						<input type="text" class="form-control" :id="`${i}animated-image${index}`" v-model="componentItem.content[i]">
					</div>
				</div>
			</div>
		</template>
		<BackgroundAudio :componentItemContent="componentItem.content" />
	</div>
</template> 

<script>
	import BackgroundAudio from '../BackgroundAudio';
	export default {
		
		name: 'ImageAndBodyCopy',
		
		props: ['componentItem', 'index'],

		components: {
			BackgroundAudio
		}
		
	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';

	label {
		display: block
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>